import { Text, View } from '@react-pdf/renderer'

const PDFTitle = ({ children, color = 'black', fontSize = 52 }) => (
  <View>
    <View style={{ marginTop: 30, marginBottom: 30 }}>
      {typeof children === 'string' ? (
        <Text style={{ fontWeight: 'bold', fontSize, color }}>{children}</Text>
      ) : (
        children
      )}
    </View>
  </View>
)

export default PDFTitle
